<template>
  <div
    :class="$style.root"
    :style="{ color }"
  >
    {{ valueFormatted }}
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { number, string } from 'vue-types';

import { formatCurrency } from '@/store/currency';
import { info } from '@/store/mainInfo';

const { locale } = useI18n();

const props = defineProps({
  value: number().isRequired,
  currency: string(),
  color: string(),
});

const valueFormatted = computed(() => formatCurrency(
  props.value,
  locale.value,
  props.currency ?? info.value.currency,
));
</script>

<style lang="scss" module>
@import "~@/styles/variables.scss";

.root {
  white-space: nowrap;
}

.rootPositive {
  composes: root;
  color: $color-green;
}

.rootNegative {
  composes: root;
  color: $color-red;
}
</style>
